if (!customElements.get('show-more-text')) {
  class ShowMoreText extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('.show-more-text__content');
      this.button = this.querySelector('.show-more-text__btn');

      this.state = false;

      this.initializeState();
      this.setupButton();
    }

    initializeState() {
      this.state = false; // Start with "less" content (content_more hidden)
      this.content.setAttribute('data-show', this.state);
      this.button.textContent = this.button.dataset.showMore;
      this.button.setAttribute('aria-expanded', 'false');
    }

    setupButton() {
      this.button.addEventListener('click', () => this.toggleContent());
    }

    toggleContent() {
      this.state = !this.state;
      // When state is true (showing more), show "less" button. When false (showing less), show "more" button
      this.button.textContent = this.state ? this.button.dataset.showLess : this.button.dataset.showMore;
      this.content.setAttribute('data-show', this.state);
      this.button.setAttribute('aria-expanded', this.state ? 'true' : 'false');
    }
  }

  customElements.define('show-more-text', ShowMoreText);
}